<template>
  <div class="factorsData">
    <div v-if="factorsData">
      <b-tabs content-class="mt-3">
        <b-tab
          v-for="(segment, segment_num) in factorsData"
          :title="'Раздаточный рукав ' + (segment_num + 1)"
          :key="segment_num"
        >
          <b-tabs content-class="mt-3">
            <b-tab
              v-for="(data, diking_id) in segment"
              :title="getDikingName(data[0].diking)"
              :key="`segment-${diking_id}`"
            >
              <b-card no-body class="mb-1" v-for="(factorInfo, index) in data" :key="`factorInfo-${index}`">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle="'accordion-' + diking_id + '-' + index" variant="info"
                    >{{ factorInfo.name }} (<span style="display: inline; font-size: unset" v-if="factorInfo.nums"
                      >Сценарии № {{ factorInfo.nums.join(", ") }}</span
                    ><span v-else style="display: inline; font-size: unset">Сценарий № {{ factorInfo.num }}</span
                    >. Вероятность: <span style="display: inline" v-html="toNormal(factorInfo.Q)"></span>)</b-button
                  >
                </b-card-header>
                <b-collapse
                  :id="'accordion-' + diking_id + '-' + index"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <div v-if="factorInfo.factor == 1">
                      <highcharts
                        :options="{
                          series: [
                            { data: factorInfo.Y, name: 'Интенсивность теплового излучения пожара пролива, кВт/м2' },
                          ],
                          title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                          yAxis: {
                            min: 0,
                            title: {
                              text: 'кВт/м2',
                            },
                          },
                          xAxis: {
                            minRange: 1,
                            tickmarkPlacement: 'on',
                            title: {
                              text: 'Расстояние, м.',
                            },
                          },
                        }"
                      ></highcharts>
                    </div>
                    <div v-if="factorInfo.factor == 2">
                      <highcharts
                        :options="{
                          series: [{ data: factorInfo.P, name: 'Избыточное давление ΔP, кПа' }],
                          title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                          yAxis: {
                            min: 0,
                            title: {
                              text: 'кПа',
                            },
                          },
                          xAxis: {
                            minRange: 1,
                            tickmarkPlacement: 'on',
                            title: {
                              text: 'Расстояние, м.',
                            },
                          },
                        }"
                      ></highcharts>
                      <highcharts
                        :options="{
                          series: [{ data: factorInfo.I, name: 'Импульс фазы сжатия I+, кПа×c' }],
                          title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                          yAxis: {
                            min: 0,
                            title: {
                              text: 'кПа×c',
                            },
                          },
                          xAxis: {
                            minRange: 1,
                            tickmarkPlacement: 'on',
                            title: {
                              text: 'Расстояние, м.',
                            },
                          },
                        }"
                      ></highcharts>
                    </div>
                    <div v-if="factorInfo.factor == 3">
                      <h5>{{ factorInfo.name }} (Сценарий № {{ factorInfo.num }})</h5>
                      Радиус воздействия продуктов сгорания паровоздушного облака в случае воздействия пожара-вспышки:
                      {{ factorInfo.Rf.toFixed(2) }} м.
                    </div>
                    <div v-if="factorInfo.factor == 4">
                      <highcharts
                        :options="{
                          series: [
                            { data: factorInfo.Y, name: 'Интенсивность теплового излучения огненного шара, кВт/м2' },
                          ],
                          title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                          yAxis: {
                            min: 0,
                            title: {
                              text: 'кВт/м2',
                            },
                          },
                          xAxis: {
                            minRange: 1,
                            tickmarkPlacement: 'on',
                            title: {
                              text: 'Расстояние, м.',
                            },
                          },
                        }"
                      ></highcharts>
                    </div>
                    <div v-if="factorInfo.factor == 5">
                      <h5>{{ factorInfo.name }} (Сценарий № {{ factorInfo.num }})</h5>
                      Размеры горизонтального факела при струйном горении:<br />
                      Диаметр: {{ factorInfo.D.toFixed(2) }} м.<br />
                      Длина: {{ factorInfo.L.toFixed(2) }} м.<br />
                    </div>
                    <div v-if="factorInfo.factor == 6">
                      <highcharts
                        :options="{
                          series: [
                            {
                              data: factorInfo.Y,
                              name: 'Интенсивность теплового излучения вертикального факела, кВт/м2',
                            },
                          ],
                          title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                          yAxis: {
                            min: 0,
                            title: {
                              text: 'кВт/м2',
                            },
                          },
                          xAxis: {
                            minRange: 1,
                            tickmarkPlacement: 'on',
                            title: {
                              text: 'Расстояние, м.',
                            },
                          },
                        }"
                      ></highcharts>
                    </div>
                    <div v-if="factorInfo.factor == 7">
                      <highcharts
                        :options="{
                          series: [{ data: factorInfo.P, name: 'Избыточное давление ΔP, кПа' }],
                          title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                          yAxis: {
                            min: 0,
                            title: {
                              text: 'кПа',
                            },
                          },
                          xAxis: {
                            minRange: 1,
                            tickmarkPlacement: 'on',
                            title: {
                              text: 'Расстояние, м.',
                            },
                          },
                        }"
                      ></highcharts>
                      <highcharts
                        :options="{
                          series: [{ data: factorInfo.I, name: 'Импульс фазы сжатия I+, кПа×c' }],
                          title: { text: factorInfo.name + ' (Сценарий № ' + factorInfo.num + ')' },
                          yAxis: {
                            min: 0,
                            title: {
                              text: 'кПа×c',
                            },
                          },
                          xAxis: {
                            minRange: 1,
                            tickmarkPlacement: 'on',
                            title: {
                              text: 'Расстояние, м.',
                            },
                          },
                        }"
                      ></highcharts>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-tab>
          </b-tabs>
        </b-tab>
      </b-tabs>
    </div>
    <div v-else>
      <center>
        <h3>Обьект не рассчитан или во время загрузки возникли ошибки</h3>
      </center>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
export default {
  name: "factorsDataPipelines",
  props: {
    object: Object,
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      factorsData: {},
    };
  },
  watch: {
    object() {
      this.fetchData();
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    getDikingName(diking) {
      if (diking.diking_id == "free_area") {
        return "Свободная площадка";
      } else {
        return "Обвалование " + diking.name;
      }
    },
    fetchData() {
      this.$http
        .get("risk/objects/get-factors-data", {
          params: {
            id: this.object.id,
            obj_type: this.object.obj_type,
          },
        })
        .then((response) => {
          this.factorsData = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    toNormal(val) {
      if (String(val).includes("e-")) {
        val = String(val);
        val = val.split("e-");
        return parseFloat(val[0]).toFixed(2) + "⋅10<sup>-" + val[1] + "</sup>";
      } else {
        val = String(val);
        var multiply = 0;
        for (var i in val) {
          if (val[i] == "0" || val[i] == ".") {
            multiply++;
          } else {
            break;
          }
        }
        if (multiply > 1) {
          val = val * Math.pow(10, multiply - 1);
          parseFloat(val).toFixed(2);
          return Math.floor(val * 100) / 100 + "⋅10<sup>-" + (multiply - 1) + "</sup>";
        } else {
          return parseInt(val).toFixed(2);
        }
      }
    },
  },
};
</script>
